import React, { useEffect, useState } from 'react'
import axios from 'axios'
// import PropTypes from 'prop-types'

// Components
// import HeaderPeopleOrg from 'Components/Organisms/Personas/Header'
// import FooterPeopleOrg from 'Components/Organisms/Personas/Footer'
// import C01NotificationPeopleOrg from 'Components/Organisms/Personas/C01Notification'
// import C01LoginPeopleOrg from 'Components/Organisms/Personas/C01Login'
// import C08PeopleOrg from 'Components/Organisms/Personas/C08'
// import C08V2PeopleOrg from 'Components/Organisms/Personas/C08/v2'
// import C23PeopleOrg from 'Components/Organisms/Personas/C23'
// import C25PeopleOrg from 'Components/Organisms/Personas/C25'
// import C26PeopleOrg from 'Components/Organisms/Personas/C26'
// import C27PeopleOrg from 'Components/Organisms/Personas/C27'
// import C28PeopleOrg from 'Components/Organisms/Personas/C28'
// import C29PeopleOrg from 'Components/Organisms/Personas/C29'
// import C43PeopleOrg from './../../../Components/Organisms/Personas/C43'
// import SuccessfulRechargePeopleOrg from 'Components/Organisms/Personas/SuccessfulRecharge'
import Perfilador1Org from './../../../Components/Organisms/Personas/Perfilador1'
import Perfilador2Org from './../../../Components/Organisms/Personas/Perfilador2'
import Perfilador3Org from './../../../Components/Organisms/Personas/Perfilador3'
import Perfilador4Org from './../../../Components/Organisms/Personas/Perfilador4'
import Perfilador4Ver2Org from './../../../Components/Organisms/Personas/Perfilador4/version2'
// import SimpleFooterOrg from 'Components/Organisms/Personas/Footer/Simple'

import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// function TituloModulo(props){
//     const {
//         titulo,
//     } = props
//     return (
//         <section style={{padding: 0, backgroundColor: '#999'}}>
//             <div className="container" style={{position: 'relative'}} > 
//                 <h1 style={{fontSize: '20px', fontWeight: '600', padding: '5px 10px', color: '#fff', zIndex: 1}}>
//                     {titulo}
//                 </h1>
//             </div>
//         </section>
//     )
// }

// TituloModulo.protoType = {
//     titile: PropTypes.string,
// }

function HomePeopleContainerUi(props) {
    // const {
    //     dataCompare
    // } = props
    const [currentPage, setCurrentPage] = useState('Perfilador1Org')
    const [sections, setSections] = useState([])
    const [questionsAnswers, setQuestionsAnswers] = useState([])
    const [activePage, setActivePage] = useState(0)
    //const [ponderacion, setPonderacion] = useState(0)
    const [contenidoSel, setContenidoSel] = useState([
        { desc: 'Hogar', value: 'Hasta 79m²', ponderacion:'10' },
        { desc: 'Estructura', value: '', ponderacion:'' },
        { desc: 'UsoD', value: 0, showddispositivo: []}
    ])
    const [dataPlanes, setDataPlanes] = useState([])
    const [dataLegales, setDataLegales] = useState([])

    async function GetPlanes() {
        let url_servicio_web = localStorage.getItem('url_servicio_web') ? localStorage.getItem('url_servicio_web') : ''
        const id_familia = localStorage.getItem('id_familia')
        const PlanesConf = {
            method: 'GET',
            data: {},
            url: url_servicio_web + "get_cplanes?fi_familia=" + id_familia,
            headers: {
                'Content-Type': "application/json",
            },
        };
        let response = await axios(PlanesConf)
        // let Consulta_de_SaldoAll = ''
        if (response?.data) {
            setDataPlanes(response.data)
        }
        console.log("response - GetPlanes------------------------->", response?.data, response);
    }

    async function GetLegales() {
        let url_servicio_web = localStorage.getItem('url_servicio_web') ? localStorage.getItem('url_servicio_web') : ''

        const LegalesConf = {
            method: 'GET',
            data: {},
            url: url_servicio_web + "get_perfilador_legales",
            headers: {
                'Content-Type': "application/json",
            },
        };
        let response = await axios(LegalesConf)
        // let Consulta_de_SaldoAll = ''
        if (response?.data) {
            setDataLegales(response.data)
        }
        console.log("response - GetLegales------------------------->", response?.data, response);
    }


    useEffect(() => {
        GetSections()
        GetPlanes()
        GetLegales()
        // eslint-disable-next-line
    }, [])

    async function GetSections() {
        let url_servicio_web = localStorage.getItem('url_servicio_web') ? localStorage.getItem('url_servicio_web') : ''
        const SeccionesConf = {
            method: 'GET',
            url: url_servicio_web + "get_secciones",
            headers: {
                'Accept': "application/json",
            },
        };
        let response = await axios(SeccionesConf)
        // let Consulta_de_SaldoAll = ''
        if (response?.data) {
            setSections(response.data)
            getQuestionsAnswers(response.data)
        }
        console.log("response - GetSecciones------------------------->", response?.data, response);
    }
    async function getQuestionsAnswers(dataSections) {
        let url_servicio_web = localStorage.getItem('url_servicio_web') ? localStorage.getItem('url_servicio_web') : ''
        let seccionName = "", dataAsks = []
        for (let i = 0; i < dataSections.length; i++) {
            seccionName = dataSections[i].fc_SECCION
            const asksConfig = {
                method: 'POST',
                url: url_servicio_web + "get_preguntas_by_seccion?seccion=" + seccionName,
                headers: {
                    'Accept': "application/json",
                },
            };
            try {
                let response = await axios(asksConfig)
                console.log("response-----", response)
                // let Consulta_de_SaldoAll = ''
                if (response?.data) {
                    console.log("ingreso------------------", seccionName)
                    dataAsks.push(response.data)
                    if (seccionName === 'DIS') {
                        let newVal = 0

                        const val = {
                            desc: 'Dispositivos',
                            value: newVal,
                            showddispositivo: []
                        }
                        let newcontenidoSel = contenidoSel
                        const Dispositivos = contenidoSel.find(c => c.desc === 'Dispositivos')
                        // console.log("Dispositivos getQuestionsAnswers......", Dispositivos, contenidoSel)
                        if (Dispositivos === undefined) {
                            newcontenidoSel.push(val)
                            setContenidoSel(newcontenidoSel)
                        }
                    }
                }
                console.log("response - getQuestionsAnswers------------------------->", seccionName, response);
            } catch (error) {
                console.log("Error en sección", seccionName, error)
            }

        }
        console.log("dataAsks------------------------->", dataAsks);
        setQuestionsAnswers(dataAsks)
    }

    const handleChangeCurrentPage = (el, backTo, page) => {
        let currentPage = el?.target.value === 'Perfilador3Org' && page === 3 ? 'Perfilador4Org' : el?.target.value
        // let planId = parseInt(el.target.name)
        console.log("handleChangeCurrentPage is:.................... ", el?.target.value, backTo, page, currentPage);
        if (currentPage) {
            setCurrentPage(currentPage)
            if (page === 'init') {
                console.log("init page____________________")
                setContenidoSel([
                    { desc: 'Hogar', value: 'Hasta 79m²', ponderacion:'10' },
                    { desc: 'Estructura', value: '', ponderacion:'' },
                    { desc: 'Dispositivos', value: 0, showddispositivo: []},
                    { desc: 'UsoD', value: 0, showddispositivo: []}
                ])
                setActivePage(0)
                GetSections()
            } else {
                setActivePage(page)
            }
        } else {
            setCurrentPage(backTo)
            setActivePage(0)
        }

    }

    function handleChangeAnswerSelected(el, InputValNum = null, ponderacion = null) {
        let askQ = parseInt(el?.target.name.split("_")[0])
        let askQName = el?.target.name
        let askResp = el?.target.value.split('|_|')
        let askRespIDValue = parseInt(askResp[0])
        let askRespChecked = el?.target?.checked
        let questionsAnswersBK = [...questionsAnswers]
        console.log("handleChangeAnswerSelected, ponderacion,", ponderacion, el)
        const contenido = contenidoSel.find(c => c.desc === askResp[2])
        if (contenido) {
            contenido.value = askResp[3]
            contenido.ponderacion = askResp[1]
            setContenidoSel(contenidoSel)
        } else if (askResp[1]) {
            const val = {
                desc: askResp[2] ? askResp[2] : '',
                value: askResp[3]
            }
            contenidoSel.unshift(val)
            setContenidoSel(contenidoSel)
        }

        console.log("handleChangeAnswerSelected is: " + askQ, askRespIDValue, askRespChecked, askQName, "InputValNum", InputValNum);
        let newquestionsAnswers = questionsAnswersBK[activePage].map((ask, index) => {
            if (ask.fi_PREGUNTA === askQ) {
                let newperfiladorRespuestas = [], addIdAnsw = 0
                const seccion = ask.fc_SECCION
                newperfiladorRespuestas = ask.perfiladorRespuestas.map((answ) => {
                    let newAns = answ
                    let ansName = askQ + "_" + answ.fi_RESPUESTA
                    // console.log("perfiladorRespuestas:::", newAns)
                    if (ask.fi_TIPO === 4 && (askQName === ansName)) {
                        newAns.checked = askRespChecked
                        if (seccion === 'NEC') {
                            // newAns.fi_PONDERACION = InputValNum * newAns.fi_PONDERACION
                            const UsoD = contenidoSel.find(c => c.desc === 'UsoD')
                            if (askRespChecked) {
                                if (UsoD) {
                                    const val = {
                                        id_respuesta: newAns.fi_RESPUESTA,
                                        id_askQ: askQ,
                                        titulo: newAns.fc_TITULO,
                                        value: newAns.fi_PONDERACION
                                    }
                                    UsoD.showddispositivo.push(val)
                                    UsoD.value = UsoD.showddispositivo.length
                                    setContenidoSel(contenidoSel)
                                }
                            } else {
                                let newContenido = UsoD.showddispositivo.filter(d => d.id_respuesta !== newAns.fi_RESPUESTA)
                                UsoD.showddispositivo = newContenido
                                UsoD.value = UsoD.showddispositivo.length
                                setContenidoSel(contenidoSel)
                            }
                        }
                        console.log("perfiladorRespuestas::: checkbox fi_TIPO 4", newAns, seccion, InputValNum)
                    }
                    if (answ.fi_RESPUESTA === askRespIDValue) {
                        // newAns.selected = true
                        if (ask.fi_TIPO === 1) {
                            addIdAnsw = askRespIDValue
                            newAns.selected = true
                            console.log("perfiladorRespuestas::: addIdAnsw", newAns)
                        } else if (ask.fi_TIPO === 3 && (InputValNum || InputValNum >= newAns.fi_VALOR_MINIMO)) {
                            newAns.InputValNum = InputValNum
                            if (seccion === 'DIS') {
                                newAns.fi_PONDERACION = InputValNum * newAns.fi_PONDERACION
                                const dispositivo = contenidoSel.find(c => c.desc === 'Dispositivos')
                                if (InputValNum > 0) {
                                    if (dispositivo) {
                                        const val = {
                                            titulo: ask.fc_TITULO,
                                            value: InputValNum
                                        }
                                        dispositivo.showddispositivo.push(val)
                                        setContenidoSel(contenidoSel)
                                    }
                                } else {
                                    let newContenido = dispositivo.showddispositivo.filter(d => d.titulo !== ask.fc_TITULO)
                                    dispositivo.showddispositivo = newContenido
                                    setContenidoSel(contenidoSel)
                                }
                            }
                            console.log("perfiladorRespuestas::: InputValNum", newAns)
                        } else if (ask.fi_TIPO === 2) {
                            newAns.selected = true
                            console.log("perfiladorRespuestas::: selected", newAns)
                        }
                    } else {
                        newAns.selected = false
                    }
                    return newAns
                })
                ask.perfiladorRespuestas = newperfiladorRespuestas
                if (addIdAnsw !== 0) {
                    ask.IdAnswSelected = addIdAnsw
                }
            }
            return ask
        })
        console.log("newquestionsAnswers newarray", newquestionsAnswers)
        questionsAnswersBK[activePage] = newquestionsAnswers
        setQuestionsAnswers(questionsAnswersBK)
        setActivePage(activePage)
    }
    console.log("questionsAnswers::::....", questionsAnswers, "contenidoSel:", contenidoSel)
    return (
        <>
            {
                currentPage === 'Perfilador1Org' ?
                    <Perfilador1Org
                        backButton={false}
                        handleChangeCurrentPage={handleChangeCurrentPage}
                        sections={sections}
                        activePage={activePage}
                        questionsAnswers={questionsAnswers}
                        handleChangeAnswerSelected={handleChangeAnswerSelected}
                        //setPonderacion={setPonderacion}
                        setContenidoSel={setContenidoSel}
                        contenidoSel={contenidoSel}
                    />
                    : null
            }
            {
                currentPage === 'Perfilador2Org' ?
                    <Perfilador2Org
                        backButton={false}
                        handleChangeCurrentPage={handleChangeCurrentPage}
                        sections={sections}
                        activePage={activePage}
                        questionsAnswers={questionsAnswers}
                        handleChangeAnswerSelected={handleChangeAnswerSelected}
                        setContenidoSel={setContenidoSel}
                        contenidoSel={contenidoSel}
                    />
                    : null
            }
            {
                currentPage === 'Perfilador3Org' ?
                    <Perfilador3Org
                        backButton={false}
                        handleChangeCurrentPage={handleChangeCurrentPage}
                        sections={sections}
                        activePage={activePage}
                        questionsAnswers={questionsAnswers}
                        handleChangeAnswerSelected={handleChangeAnswerSelected}
                        setContenidoSel={setContenidoSel}
                        contenidoSel={contenidoSel}
                    />
                    : null
            }
            {
                currentPage === 'Perfilador4OrgOld' ?
                    <Perfilador4Org
                        backButton={false}
                        handleChangeCurrentPage={handleChangeCurrentPage}
                        sections={sections}
                        activePage={activePage}
                        questionsAnswers={questionsAnswers}
                        contenidoSel={contenidoSel}
                        planes={dataPlanes}
                        legales={dataLegales}
                    />
                    : null
            }
            {
                currentPage === 'Perfilador4Org' ?
                    <Perfilador4Ver2Org
                        backButton={false}
                        handleChangeCurrentPage={handleChangeCurrentPage}
                        sections={sections}
                        activePage={activePage}
                        questionsAnswers={questionsAnswers}
                        contenidoSel={contenidoSel}
                        planes={dataPlanes}
                        legales={dataLegales}
                    />
                    : null
            }
            {/* <Perfilador2Org />
            <Perfilador3Org />
            <Perfilador4Org /> */}

        </>
    )
}

// HomePeopleContainerUi.propTypes = {

// }

export default HomePeopleContainerUi
